import * as Yup from "yup";
import formModel from './formModel';

const {
    formField: {
        names,
        lastName,
        codArea,
        phone,
        email,
        dni,
        cuit,
        address,
        sex,
        codigosLocalidad
    },
} = formModel;

const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

export default [
    Yup.object().shape({
        [names.name]: Yup.string()
            .required(`${names.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [lastName.name]: Yup.string()
            .required(`${lastName.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),

        // [nacimiento.name]: Yup.date().required(`${nacimiento.requiredErrorMsg}`).test(
        //     "nacimiento",
        //     "Debe ser mayor de 18 años para utilizar Polko.",
        //     value => {
        //         return moment().diff(moment(value),'years') >= 18;
        //     }
        // ),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
        [codArea.name]: Yup.number()
            .required(`${codArea.requiredErrorMsg}`)
            .min(11, "El código de área ingresado no es válido")
            .max(9999, "El código de área ingresado no es válido")
            .integer()
            .typeError("Introduzca únicamente números"),
        [phone.name]: Yup.string()
            .required(`${phone.requiredErrorMsg}`)
            .matches(/^\(?\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4,5})$/, "El celular ingresado no es válido"),
        [dni.name]: Yup.number()
            .required(`${dni.requiredErrorMsg}`)
            .min(1000000, "El documento ingresado no es válido")
            .max(99999999, "El documento ingresado no es válido")
            .integer()
            .typeError("Introduzca únicamente números"),
        [cuit.name]: Yup.string()
            .required(`${cuit.requiredErrorMsg}`)
            .matches(/^(20|23|24|27|30|33)[0-9]{9}$/, "El CUIT ingresado no es válido"),
        [address.name]: Yup.string()
            .required(`${address.requiredErrorMsg}`)
            .matches(/^[A-Za-z0-9 ,-]+$/, "Esta utilizando carácteres no válidos"),
        [sex.name]: Yup.string().required(
            `${sex.requiredErrorMsg}`
        ),
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
    }),
];